import { FC, useState } from 'react';
import { useAdminSuppliers } from 'store/admin-suppliers';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
>;

export const AdminSuppliersFilter: FC<Props> = (props) => {
  const [search, setSearch] = useState('');

  const { data: suppliers, isLoading } = useAdminSuppliers({
    name: search,
    pageSize: 99999,
  });

  return (
    <SelectFilter
      {...props}
      options={suppliers?.items.map((supplier) => ({
        key: supplier.id,
        label: supplier.name,
      }))}
      loadingOptions={isLoading}
      onSearch={setSearch}
      multiple
      asyncSearch
    />
  );
};
